// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4214321c","176":"e5e76138","411":"e7f525f4","787":"c0e1f8d9","818":"1d6ac436","951":"efdd61d7"}[chunkId] + ".chunk.js";
};